/**
 * Convert supplied arrays into key-value entries in an object, items with
 * matches indexes in their arrays will be paired, arrays must be of the same
 * length
 *
 * @param {Array} keys
 * @param {Array} values
 * @returns {Object}
 */
export const zipToObject = (keys, values) =>
  Object.assign(...keys.map((k, ix) => ({ [k]: values[ix] })));

// this can be removed when other util methods are added to this module
export default zipToObject;
